import { render } from "./StudentForms.vue?vue&type=template&id=455b17ce&scoped=true"
import script from "./StudentForms.vue?vue&type=script&lang=js"
export * from "./StudentForms.vue?vue&type=script&lang=js"

import "./StudentForms.vue?vue&type=style&index=0&id=455b17ce&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b17ce"]])

export default __exports__